import get from 'lodash/get'

export const currentUserNameSelector = state => {
  return get(state.auth, 'user.first_name')
}
